import { useState } from 'react';
import styles from '../styles/body.module.scss'
import btnStyles from '../styles/buttons.module.scss'
import Button from '@mui/material/Button';
import axios from '../api/axios';
import useAxios from "../hooks/useAxios";
import useAxiosFunction from '../hooks/useAxiosFunction';
import Autocomplete from '@mui/material/Autocomplete';
import {Box, TextField} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import { useNavigate } from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import{BottomNavigation, BottomNavigationAction} from '@mui/material'

export default function MemberOfThePublic({categoryId, setCategoryId, description, setDescription}) {

  const navigate = useNavigate();
  const goBack = () => {
    setCategoryId(null);  
    navigate(-1);
  }

  const [response, error, loading, axiosFetch] = useAxiosFunction();

  const [categoryError, setCategoryError] = useState(false);
  const [categoryText, setCategoryText] = useState('');

  const [descriptionError, setDescriptionError] = useState(false);
  const [descriptionText, setDescriptionText] = useState('');

  const [displayTrespassingMessage, setDisplayTrespassingMessage] = useState(false);

  const [category] = useAxios({
      axiosInstance:axios,
      method:'get',
      url:'/getMOPCategories'
  });

  const handleCategoryChange = (event, newValue) => {
    //display text based on category change
    if("Trespassing" == newValue.category){
      setDisplayTrespassingMessage(true);
    }
    else{
      setDisplayTrespassingMessage(false);
    }

    setCategoryId(newValue);
  };

  const handleDescriptionChange = (newValue) => {
    setDescription(newValue);
  };

  const nextPage = () => {

    if(categoryId !=null && description !== ""){
      setCategoryText('');
      setCategoryError(false);

      setDescriptionText('')
      setDescriptionError(false);

      if(description.length >250){
        setDescriptionText('Description must be less than 250 characters');
        setDescriptionError(true);
      }
      else{
        //submit observation
        navigate('/image_upload');
  
      }

    }
    else{
      setCategoryText('');
      setCategoryError(false);
      setDescriptionText('')
      setDescriptionError(false);

      if(categoryId == null){
        setCategoryText('Please select a category');
        setCategoryError(true);
      }
      if(description === ""){
        setDescriptionText('Please provide a brief description');
        setDescriptionError(true);
      }
  
    }
  
  
  }


  return (
    <div>
      
      <Box className={styles.questionH1Top} >
              <h1>Choose a category</h1>
          </Box>
          <Box className={styles.textField} >
              <FormControl fullWidth margin="normal" className={styles.field} error={categoryError}>
                  <Autocomplete
                      disablePortal
                      disableClearable
                      value={categoryId}
                      onChange={handleCategoryChange}
                      options={category}
                      getOptionLabel={(category) => category.category}
                      renderInput={(params) => (
                          <TextField {...params} label="Categories" error={categoryError} />
                      )}
                  />
                  <FormHelperText>{categoryText}</FormHelperText>
              </FormControl>
          </Box>
          {displayTrespassingMessage ?
        <>
        <Box className={styles.textPara} >
        <Box className={styles.smallRedDiv} >
        <p className={styles.smallRed}>If you believe that someone is currently trespassing on site, or if a crime is currently in progress, please call 999.</p>
        </Box>
        </Box>
        </>
        :
        <></>}
          <Box className={styles.questionH1} >
              <h1>Provide a brief description</h1>
              </Box>
              <Box className={styles.textField}>
              <FormControl fullWidth margin="normal" className={styles.field} error={descriptionError}>
                 <TextField error={descriptionError} value={description} inputProps={{maxLength: 250}} helperText={`${description.length}/${250}`} fullWidth id="outlined-basic" multiline rows={5} label="Description" variant="outlined" onChange={e => handleDescriptionChange(e.target.value)}  />
                 <FormHelperText>{descriptionText}</FormHelperText>
              </FormControl>
              </Box>
          <Box className={btnStyles.navbuttons} >
              <Button startIcon={<ArrowBackIosNewIcon />} className={btnStyles.backBtn} size="large" variant="contained" onClick={() => goBack()}>Back</Button>
              <Button endIcon={<ArrowForwardIosIcon />} className={btnStyles.nextBtn} size="large" variant="contained"
                  onClick={() => nextPage()}
              >Next</Button>

          </Box>
          <Box className={btnStyles.bottomNavContainer}>
              <BottomNavigation sx={{
                  width: '100%',
                  position: 'fixed',
                  bottom: 0,
                  height:'70px',
                  zIndex: '1000'
              }} showLabels>
                  <BottomNavigationAction id="navBackButton" label='Back' icon={<ArrowBackIosNewIcon />} onClick={() => goBack()} />
                  <BottomNavigationAction id="navNextButton" label='Next' icon={<ArrowForwardIosIcon />} onClick={() => nextPage()} />
              </BottomNavigation>
          </Box>           
        
    </div>
  );
}

